import Route from '@ember/routing/route';

export default class PrivacyRoute extends Route {}
